import { render, staticRenderFns } from "./EmailActivity.vue?vue&type=template&id=7fb85950"
import script from "./EmailActivity.vue?vue&type=script&lang=js"
export * from "./EmailActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports